<template>
  <div class="questions">
    <div class="container padding-top-90">
      <div class="row">
        <div class="col-12">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Namn</th>
                <th>Fråga</th>
                <th>Inskickad</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="questions.length == 0">
                <td colspan="3" class="text-center">Inga frågor inskickade. :(</td>
              </tr>
              <tr v-for="question in questions" :key="question.id">
                <td>{{ question.name }}</td>
                <td>{{ question.question }}</td>
                <td>{{ $DateTime.fromJSDate(question.created.toDate(), { locale: "sv-SE" }).toLocaleString($DateTime.DATETIME_SHORT_WITH_SECONDS) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  export default {
    name: "questions",
    data() {
      return {
        questions: []
      }
    },
    async mounted() {
      await this.$bind("questions", firebase.firestore().collection(`questions`).orderBy("created", "asc"))
    }
  }
</script>